import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import AdminPage from "@/pages/admin/page";
import TransferPage from "@/pages/transfer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <AdminPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/transfer",
    element: <TransferPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;